// Country deep-dive data: visa routes, timelines, costs, success stories
export const COUNTRY_DETAILS = {
  "Canada": {
    gradient: "from-[#D52B1E] to-[#0B1E3F]",
    hero: "Toronto · Vancouver · Calgary",
    routes: [
      { kind: "Work",  name: "Work Permit (LMIA / Open)",   time: "4-10 wks", cost: "CAD 2.5-6k" },
      { kind: "Study", name: "Study Permit · SDS stream",   time: "4-8 wks",  cost: "CAD 20-40k/yr" },
      { kind: "PR",    name: "Express Entry · CEC / PNP",   time: "6-11 mo",  cost: "CAD 3.5-7k" },
    ],
    stories: [
      { name: "Priya Patel",   quote: "Data scientist from Bengaluru. ITA in 8 weeks, PR card in 11." },
      { name: "Chinedu Okafor", quote: "Petroleum engineer from Lagos. Landed in Calgary in 90 days." },
    ],
  },
  "United Kingdom": {
    gradient: "from-[#012169] to-[#C8102E]",
    hero: "London · Manchester · Edinburgh",
    routes: [
      { kind: "Work",  name: "Skilled Worker (sponsored)", time: "3-8 wks", cost: "£1.5-4k + visa fees" },
      { kind: "Study", name: "Student Visa + Graduate",   time: "3-6 wks", cost: "£15-35k/yr" },
      { kind: "PR",    name: "ILR after 5 yrs residence", time: "4 wks",   cost: "£2.9k" },
    ],
    stories: [
      { name: "Adaeze Nwosu", quote: "Nurse practitioner — UK Skilled Worker route, zero rejections." },
      { name: "Charlotte B.", quote: "Barrister moved to Sydney first, now UK ILR confirmed." },
    ],
  },
  "Australia": {
    gradient: "from-[#00843D] to-[#FFCD00]",
    hero: "Sydney · Melbourne · Perth",
    routes: [
      { kind: "Work",  name: "Subclass 482 TSS",     time: "3-6 wks",  cost: "AUD 3-6k" },
      { kind: "Study", name: "Subclass 500 Student", time: "4-8 wks",  cost: "AUD 25-45k/yr" },
      { kind: "PR",    name: "Subclass 189 / 190",   time: "5-10 mo",  cost: "AUD 4.6k+" },
    ],
    stories: [
      { name: "Charlotte Bennett", quote: "Subclass 189 approved — Australia felt impossible until NextShore mapped it." },
      { name: "Mei Lin Wong",      quote: "PR in 5 months with RFEs handled calmly." },
    ],
  },
  "Germany": {
    gradient: "from-[#000000] via-[#DD0000] to-[#FFCE00]",
    hero: "Berlin · Munich · Hamburg",
    routes: [
      { kind: "Work",  name: "EU Blue Card",                 time: "4-8 wks", cost: "€500-1.5k" },
      { kind: "Study", name: "Student Visa + Chancenkarte", time: "6-10 wks", cost: "€10-20k/yr" },
      { kind: "PR",    name: "Settlement after 21-33 mo",   time: "6-12 wks", cost: "€250" },
    ],
    stories: [
      { name: "Arjun Mehta", quote: "EU Blue Card to Berlin in 4 months. Discreet and precise." },
    ],
  },
  "UAE": {
    gradient: "from-[#00732F] to-[#000000]",
    hero: "Dubai · Abu Dhabi",
    routes: [
      { kind: "Work",  name: "Employment Visa (standard)", time: "2-4 wks", cost: "AED 3-7k" },
      { kind: "Study", name: "Student Residence",          time: "3-5 wks", cost: "AED 40-90k/yr" },
      { kind: "PR",    name: "Golden Visa (10-yr)",        time: "3-6 wks", cost: "AED 2.8-10k" },
    ],
    stories: [
      { name: "James Whitmore", quote: "Golden Visa for my whole fintech team — ridiculously smooth." },
    ],
  },
  "Singapore": {
    gradient: "from-[#EF3340] to-[#FFFFFF]",
    hero: "Singapore CBD",
    routes: [
      { kind: "Work",  name: "Employment Pass",         time: "3-6 wks", cost: "S$225 fees" },
      { kind: "Study", name: "Student Pass",            time: "4-8 wks", cost: "S$30-55k/yr" },
      { kind: "PR",    name: "ONE Pass / PR pathway",   time: "4-10 mo", cost: "S$525" },
    ],
    stories: [
      { name: "Wei Zhang", quote: "ONE Pass approved on the first try." },
    ],
  },
  "USA": {
    gradient: "from-[#3C3B6E] to-[#B22234]",
    hero: "New York · San Francisco · Austin",
    routes: [
      { kind: "Work",  name: "H1B / L1 / O1",             time: "3-9 mo",  cost: "$3-10k" },
      { kind: "Study", name: "F1 Student + OPT",          time: "6-12 wks", cost: "$30-70k/yr" },
      { kind: "PR",    name: "EB-1 / EB-2 NIW · Green Card", time: "12-30 mo", cost: "$8-20k" },
    ],
    stories: [
      { name: "Isabela Costa", quote: "Switched visas mid-flight. Every document pre-reviewed." },
    ],
  },
  "Ireland": {
    gradient: "from-[#169B62] to-[#FF883E]",
    hero: "Dublin · Cork",
    routes: [
      { kind: "Work",  name: "Critical Skills Permit", time: "4-10 wks", cost: "€1k" },
      { kind: "Study", name: "Stamp 2 Student",        time: "4-8 wks",  cost: "€10-25k/yr" },
      { kind: "PR",    name: "Stamp 4 Long-term",      time: "6-10 wks", cost: "€300" },
    ],
    stories: [
      { name: "Isabela Costa", quote: "Irish work permit without a hitch." },
    ],
  },
  "New Zealand": {
    gradient: "from-[#012169] to-[#C8102E]",
    hero: "Auckland · Wellington",
    routes: [
      { kind: "Work",  name: "Accredited Employer Work Visa", time: "4-10 wks", cost: "NZ$750" },
      { kind: "Study", name: "Fee-paying Student",            time: "4-8 wks",  cost: "NZ$25-45k/yr" },
      { kind: "PR",    name: "Skilled Migrant Category",      time: "6-12 mo",  cost: "NZ$4.6k" },
    ],
    stories: [
      { name: "Angelica Cruz", quote: "Skilled migrant felt personal, not procedural." },
    ],
  },
  "Netherlands": {
    gradient: "from-[#AE1C28] to-[#21468B]",
    hero: "Amsterdam · Rotterdam",
    routes: [
      { kind: "Work",  name: "Highly Skilled Migrant / DAFT", time: "2-6 wks", cost: "€380-1k" },
      { kind: "Study", name: "Student Residence",             time: "4-8 wks", cost: "€12-20k/yr" },
      { kind: "PR",    name: "Settlement after 5 yrs",        time: "4-8 wks", cost: "€220" },
    ],
    stories: [
      { name: "Neha Iyer", quote: "DAFT visa in six weeks — still can't believe it." },
    ],
  },
  "Portugal": {
    gradient: "from-[#006600] to-[#FF0000]",
    hero: "Lisbon · Porto",
    routes: [
      { kind: "Work",  name: "D1 / D3 Highly Qualified", time: "6-10 wks", cost: "€200-500" },
      { kind: "Study", name: "D4 Student",               time: "6-10 wks", cost: "€3-8k/yr" },
      { kind: "PR",    name: "D7 / D2 → Residence",      time: "8-14 wks", cost: "€520+" },
    ],
    stories: [
      { name: "Lucas Oliveira", quote: "Portugal D2 visa in 10 weeks — white-glove." },
    ],
  },
};
